import { SetupIntent } from '@arcadiapower/shrike';
import { PropsWithChildren } from 'react';
import { STRIPE_KEY } from '~/utils/constants';
import { StyledPaymentMethodForm } from './payment-form.style';

export interface PaymentFormProps {
  onSubmit: (setupIntent: SetupIntent) => void;
  pending?: boolean;
  stripeToken: string;
  locale?: string;
}

export const PaymentForm = ({
  children,
  onSubmit,
  pending,
  stripeToken,
  locale,
}: PropsWithChildren<PaymentFormProps>) => {
  if (!stripeToken) return null;
  return (
    <StyledPaymentMethodForm
      redirectUrl="https://www.arcadia.com"
      paymentMethodOrder={['us_bank_account', 'card', 'cashapp']}
      loading={pending}
      onSubmit={onSubmit}
      stripeKey={STRIPE_KEY}
      stripeClientSecret={stripeToken}
      locale={locale}
    >
      {children}
    </StyledPaymentMethodForm>
  );
};
